'use es6';

import { createSelector } from 'reselect';
import SeamlessImmutable from 'seamless-immutable';
import { isEqual } from 'underscore';
import { EMPTY_OBJECT } from 'DesignData/lib/object';

const getJavaScriptLinter = state => state.userSettings.javaScriptLinter;

export const getIsEnabled = state => getJavaScriptLinter(state).isEnabled;
export const getEslintConfig = state => getJavaScriptLinter(state).eslintConfig;
export const getEslintConfigError = state => getJavaScriptLinter(state).eslintConfigError;
export const getEslintDemoErrors = state => getJavaScriptLinter(state).eslintDemoErrors;
export const getUserSettings = (() => {
  let state = EMPTY_OBJECT;
  return createSelector([getIsEnabled, getEslintConfig], (isEnabled, eslintConfig) => {
    state = SeamlessImmutable.merge(state, {
      isEnabled,
      eslintConfig
    });
    return state;
  });
})();
export const getEslintConfigObject = (() => {
  let state = EMPTY_OBJECT;
  return createSelector([getEslintConfig], json => {
    let configObject;

    try {
      configObject = JSON.parse(json);
    } catch (e) {
      configObject = EMPTY_OBJECT;
    }

    if (isEqual(state, configObject)) {
      return state;
    }

    state = SeamlessImmutable.merge(state, configObject);
    return state;
  });
})();